export const SearchSkeletonComponent = {
  bindings: {},
  templateUrl: 'components/Skeletons/search-skeleton/search-skeleton.html',
  controller: class SearchSkeletonController {},
};
